/**
 * Returns the emoji flag for a given ISO 3166-1 alpha-2 country code.
 * @param countryCodeAlpha2
 */
export const isoCountryCodeToEmoji = (countryCodeAlpha2: string) => {
  const codePoints = countryCodeAlpha2
    .toUpperCase()
    .split('')
    // eslint-disable-next-line unicorn/prefer-code-point
    .map((char) => 127_397 + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
};
